import * as lef_slider from '../slider/slider.js';
import './featured-products.scss';
export default (() => {
  lef_slider.generateSliders('.featured-products');
});